const ERROR_ICON = 'core/status/ic_close_circle_fill'

export { ERROR_ICON }
